import { Component, EventEmitter, Output } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';

import { LabelService } from '../../../services/label.service';
import {
  StatoFatturaSDI,
  StatoFatturaSTS,
  spiegazioneStatoFatturaSDI,
  spiegazioneStatoFatturaSTS,
} from '../../../models/invoices';

@Component({
  selector: 'app-invoices-info-panel',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './invoices-info-panel.component.html',
  styleUrl: './invoices-info-panel.component.scss',
})
export class InvoicesInfoPanelComponent {
  @Output() close = new EventEmitter<void>();

  statiSTS = Object.entries(spiegazioneStatoFatturaSTS);
  statiSDI = Object.entries(spiegazioneStatoFatturaSDI);

  constructor(public labelService: LabelService) {}

  onClose() {
    this.close.emit();
  }
}
